function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import Vue from "vue";
import { extend as extend$2 } from "@opentiny/vue-renderless/common/object";
import { formatNumber as _formatNumber, recoverNumber as _recoverNumber } from "@opentiny/vue-renderless/common/decimal";
import { toDate, getDateWithNewTimezone as _getDateWithNewTimezone } from "@opentiny/vue-renderless/common/date";
import { isPlainObject, isNumber, isNull, isDate } from "@opentiny/vue-renderless/common/type";
import { formatDate as _formatDate } from "@opentiny/vue-renderless/common/deps/date-util";
var zhCN$1 = {
  "en-US": "English",
  "zh-CN": "中文",
  "zh-TW": "中国台湾",
  hello: "你好 {name}",
  code: "zh-CN",
  ui: {
    buttonMessage: {
      cancel: "取消",
      confirm: "确定"
    },
    wizard: {
      previousStep: "上一步",
      nextStep: "下一步",
      save: "保存",
      submit: "提交"
    },
    linkMenu: {
      title: "消息",
      placeholder: "请输入关键字过滤...",
      sure: "确定",
      cancel: "取消"
    },
    todoList: {
      add: "提交",
      placeholder: "请输入内容..."
    },
    alert: {
      error: "错误",
      info: "消息",
      success: "成功",
      title: "消息提示",
      warning: "警告"
    },
    amount: {
      currency: "币种",
      amount: "金额",
      date: "日期"
    },
    actionMenu: {
      moreText: "更多"
    },
    base: {
      all: "全部",
      cancel: "取消",
      confirm: "确定",
      delete: "删除",
      edit: "编辑",
      more: "更多",
      reset: "重置"
    },
    button: {
      cancel: "取消",
      confirm: "确认"
    },
    cell: {
      placeholder: "请选择"
    },
    cascader: {
      noMatch: "无匹配数据",
      loading: "加载中",
      placeholder: "请选择",
      noData: "暂无数据"
    },
    chart: {
      auxiliary: "辅助",
      emptyText: "暂无数据",
      kName: "日K",
      other: "其他",
      summation: "总量",
      total: "总计",
      value: "数值"
    },
    creditCardForm: {
      submit: "提交"
    },
    crop: {
      cropImage: "图片裁剪",
      croppedImage: "裁剪后图像"
    },
    datepicker: {
      clear: "清空",
      cancel: "取消",
      endDate: "结束日期",
      confirm: "确定",
      month: "月",
      endTime: "结束时间",
      month2: "2 月",
      month1: "1 月",
      month4: "4 月",
      month3: "3 月",
      month6: "6 月",
      month5: "5 月",
      month8: "8 月",
      month7: "7 月",
      month10: "10 月",
      month9: "9 月",
      month12: "12 月",
      month11: "11 月",
      months: {
        feb: "二月",
        jan: "一月",
        apr: "四月",
        mar: "三月",
        jun: "六月",
        may: "五月",
        aug: "八月",
        jul: "七月",
        oct: "十月",
        sep: "九月",
        dec: "十二月",
        nov: "十一月"
      },
      nextYear: "后一年",
      nextMonth: "下个月",
      prevMonth: "上个月",
      now: "此刻",
      selectDate: "选择日期",
      prevYear: "前一年",
      startDate: "开始日期",
      selectTime: "选择时间",
      today: "今天",
      currentMonth: "本月",
      startTime: "开始时间",
      week: "周次",
      weeks: {
        mon: "一",
        sun: "日",
        wed: "三",
        tue: "二",
        fri: "五",
        thu: "四",
        sat: "六"
      },
      timezone: "选择时区",
      year: "年",
      to: "至"
    },
    calendar: {
      showType: {
        year: "年"
      }
    },
    dept: {
      code: "编码",
      company: "公司",
      dept1: "一级部门",
      dept2: "二级部门",
      dept3: "三级部门",
      dept4: "四级部门",
      dept5: "五级部门",
      dept6: "六级部门",
      dept7: "七级部门",
      dept8: "八级部门",
      input: "可输入部门编码或名称",
      name: "名称",
      search: "辅助查询",
      selected: "已选"
    },
    detailpage: {
      saveButtonText: "确认",
      cancelButtonText: "取消",
      localTips: "不能全部隐藏",
      localTitle: "数据",
      valueTitle: "勾选隐藏",
      labelTitle: "文本字段",
      dialogTitle: "个性化标题"
    },
    dialogBox: {
      confirm: "确定",
      cancel: "取消"
    },
    load: {
      dot: "加载中"
    },
    exception: {
      build: "模块正在建设中",
      busy: "系统繁忙，请稍等一下",
      noperm: "茫茫大海，找不到页面",
      weaknet: "网络不给力",
      pcview: "请到PC上查看文件",
      nodata: "休息一下",
      create: "创建",
      provide: "TINY 开发团队提供",
      nodatamf: "暂无数据",
      nopermmf: "无访问权限",
      weaknetmf: "网络异常",
      noresult: "无相关搜索结果",
      nonews: "暂无最新消息",
      pagenoperm: "403:无访问权限",
      pageweaknet: "网络异常",
      pagenothing: "404:你访问的页面不存在",
      pageservererror: "500:服务器异常"
    },
    fileUpload: {
      largefile: "文件过大，将会分片上传，请耐心等待!",
      folder: "文件所在文件夹层数已超过 5 层，将不会上传该文件",
      init: "服务报错，请重试",
      token: "请先进行 EDM 鉴权，获取 token",
      exceed: "文件上传失败：大小超过限制（{maxSize}MB）",
      largeFile: "文件大小超出限制 2G ！！！",
      fileSize: "{name}大小不能小于 ",
      deleteTip: "按 delete 键可删除",
      downloadFile: "下载文件",
      previewFile: "预览文件",
      updateFile: "更新文件",
      deleteFile: "删除文件",
      empty: "是空文件！",
      kiaScanTip: "抱歉，从公网接入下载文档，需要通过KIA检测；当前文档正在KIA检测中，请稍后几分钟后再下载！",
      fileNameExceeds: "超过255个字符，请修改文件名。",
      fileName: "该文件名",
      calcHash: "文档正在计算加密中",
      uploadFile: "文件上传",
      downloadAll: "全部下载",
      onlySupport: "仅支持{type}格式文件",
      fileNotLessThan: "文件不能小于",
      fileNotMoreThan: "文件不能超过",
      notSupport: "文件上传失败：不支持该格式（.{format}）",
      attachment: "附件",
      uploadList: "上传列表",
      numberExceed: "文件上传失败：批量上传个数超过限制（{number}）"
    },
    uploadList: {
      pictureUploading: "图片上传中",
      uploadFailed: "上传失败",
      uploading: "上传中",
      download: "下载",
      reUpload: "重新上传",
      delete: "删除",
      noAttachments: "暂无附件",
      cancel: "取消",
      preview: "预览",
      releaseAndUpload: "释放鼠标，上传文件",
      dragOrClickImport: "将文件拖到此处，或点击导入",
      shoot: "拍摄",
      selectFromAlbum: "从相册选择",
      uploadFailedAndReupload: "上传失败，点击重新上传"
    },
    upload: {
      addPicture: "添加图片",
      addAudio: "添加音频",
      addVideo: "添加视频"
    },
    grid: {
      dataUnchanged: "数据未改动！",
      deleteSelectRecord: "您确定要删除所选记录吗？",
      emptyText: "暂无数据",
      error: {
        cellEditRender: "渲染器 cell-render 和 edit-render 不能同时使用",
        delGetAllRecords: "方法 getAllRecords 已废弃，请使用 getRecordset",
        delGetRecords: "方法 getRecords 已废弃，请使用 getData",
        delLabel: "参数 label 已废弃，请使用 title",
        delProp: "参数 prop 已废弃，请使用 field",
        delRevert: "方法 revert 已废弃，请使用 revertData",
        groupFixed: "如果使用分组表头，固定列必须在左右两侧",
        notDelete: "Delete 方法不存在",
        notMouse: "虚拟滚动不支持 mouse-config",
        notQuery: "query 方法不存在",
        notResizable: "横向虚拟滚动不支持 resizable",
        notSave: "save 方法不存在",
        reqModule: "缺少 {{name}} 模块",
        rowIdEmpty: "参数 row-id 不允许为空",
        scrollOriginal: "虚拟滚动启用后只能导出源数据，请将设置 original=true",
        scrollYHeight: "启用虚拟滚动必须要设置 height 或 max-height",
        toolbarId: "工具栏需要设置唯一 id",
        treeFixedExpand: "树结构的固定列与展开行功能有冲突",
        treeInsert: "树结构不支持 insert 操作",
        treeRemove: "树结构不支持 remove 操作",
        unableInsert: "无法插入到指定位置",
        dargSelf: "不允许自己给自己拖动",
        dargFixed: "固定列不允许拖动",
        remoteMethod: "个性化模板管理远端存储需要设置 multipleHistory.remoteMethod",
        remoteSelectedMethod: "个性化模板管理远端存储需要设置 multipleHistory.remoteSelectedMethod",
        chainCallError: "列的默认插槽中存在语法错误，请检查。"
      },
      filter: {
        allFilter: "全部",
        allSelect: "(全选)",
        endDate: "结束日期",
        startDate: "开始日期",
        dateTips: "请至少输入一个日期",
        clear: "清除当前列筛选",
        clearAll: "清除所有列筛选",
        confirmFilter: "筛选",
        empty: "为空",
        emptyText: "暂无数据",
        equal: "等于",
        include: "包含",
        prefix: "开头是",
        resetFilter: "重置",
        unempty: "不为空"
      },
      individuation: {
        cancelBtn: "取消",
        colConfigs: {
          visible: "显示",
          invisible: "隐藏",
          asc: "正序",
          desc: "倒序",
          unsorted: "未排序",
          frozenLeft: "左冻结",
          frozenRight: "右冻结",
          unfrozen: "未冻结",
          unfreeze: "取消冻结",
          unsort: "取消排序"
        },
        toolbar: {
          set: "设置",
          selected: "已选",
          freeze: "冻结",
          sort: "排序",
          clear: "清空",
          search: "搜索",
          all: "全选"
        },
        columnSet: "列设置",
        overwriteSave: "覆盖保存",
        saveAs: "另存为",
        saveTemplate: "存模板",
        selectTemplate: "选择模板",
        hideMsg: "至少保留一列显示",
        maxFreezeNumMsg: "冻结列不可超过6项",
        defaultTemplateName: "请输入名称，如未填写由系统按时间生成",
        reserveTemplateName: "如未填写名称将保留之前的名称",
        resetBtn: "重置",
        saveBtn: "确定",
        tabs: {
          base: {
            title: "基础设置",
            tips: "点击图标按钮设置个性化"
          },
          other: {
            title: "其他设置",
            tips: "设置服务器排序或客户端排序、每页条数大小。",
            sortType: "排序类型",
            currPageSort: "当前页数据排序",
            allDataSort: "所有数据排序",
            pageSize: "每页条数"
          }
        },
        title: "个性化设置",
        switchtitle: "模板管理",
        switchsave: "保存配置",
        switchlabel: "配置列表：",
        switchapply: "使用",
        switchedit: "编辑",
        switchdel: "删除",
        switchconfirm: "确认",
        switchonlytemp: "保存模板",
        switchtempapply: "保存并使用模板",
        switchtempoverwrite: "覆盖并使用模板",
        switchdelcon: "确定要删除这个模板？",
        switchdelyes: "确定",
        switchdelno: "取消",
        switchapplycon: "确定要使用这个模板？"
      },
      removeSelectRecord: "您确定要移除所选记录吗？",
      saveSuccess: "保存成功",
      selectOneRecord: "请至少选择一条记录！",
      isSaveMsg: "有修改的数据，是否要保存？"
    },
    hrapprover: {
      approver: "权签人",
      noselected: "没有选择权签人",
      noapprover: "没有权签人",
      remark: "备注"
    },
    imageViewer: {
      loadErrorAlt: "加载失败"
    },
    navMenu: {
      moreText: "更多"
    },
    logout: {
      in: "登录",
      out: "注销"
    },
    page: {
      goto: "前往",
      item: "条",
      next: "下一页",
      page: "条/页",
      pageClassifier: "页",
      pagesize: "条/页",
      prev: "上一页",
      total: "总条数",
      totals: "总计：",
      jump: "跳至",
      hundredThousand: "10万+",
      million: "100万+",
      tenMillion: "1千万+",
      loadingTotals: "加载总条数…"
    },
    popeditor: {
      cancel: "取 消",
      confirm: "确 认",
      historyLists: "历史数据列表",
      reset: "重 置",
      search: "查 询",
      selectionLists: "选择数据列表",
      sourceLists: "所有数据列表",
      title: "选择",
      filterNode: "输入内容进行筛选"
    },
    popupload: {
      fileName: "文件名",
      fileSize: "文件大小",
      fileStatus: "文件状态",
      uploadError: "上传失败",
      dialogTitle: "文件上传",
      cancelButtonText: "取消",
      tipsFileText: "上传提示",
      saveButtonText: "开始上传",
      uploadSuccess: "上传成功！",
      uploadButtonText: "选择文件",
      uploadsButtonText: "选择批量文件",
      errorTypeTips: "上传文件类型不匹配",
      errorNumTips: "上传文件数量超出限制,已取消该操作",
      errorSizeTips: "上传文件大小超出限制",
      limitUploadFileNumber: "上传文件数限制为",
      limitUploadFileType: "上传文件类型限制为",
      limitUploadFileSize: "上传文件大小不超过"
    },
    rate: {
      level: {
        average: "一般",
        excellent: "很好",
        fair: "差",
        good: "好",
        poor: "很差"
      }
    },
    select: {
      loading: "加载中",
      noMatch: "无匹配数据",
      noData: "暂无相关数据",
      placeholder: "请选择"
    },
    search: {
      placeholder: "搜索"
    },
    tabs: {
      moreItem: "更多"
    },
    tag: {
      add: "添加"
    },
    toggleMenu: {
      placeholder: "请输入内容进行筛选"
    },
    treeMenu: {
      placeholder: "请输入内容进行筛选"
    },
    transfer: {
      filterPlaceholder: "请输入搜索内容",
      hasCheckedFormat: "已选 {checked}/{total} 项",
      noCheckedFormat: "共 {total} 项",
      noData: "无数据",
      noMatch: "无匹配数据",
      titles: ["列表 1", "列表 2"]
    },
    tree: {
      emptyText: "暂无数据",
      switchText: "同时勾选下级",
      deleteTip: "删除后数据不可恢复，确定删除吗？",
      preserveSubnodeTip: "该节点存在下级节点，是否保留下级节点数据？",
      preserveSubnodeData: "保留下级节点数据",
      newNodeTitle: "新增下级"
    },
    usercard: {
      address: "地址",
      collapse: "收起",
      department: "部门",
      email: "邮箱",
      employeeId: "员工 ID",
      "employee_id": "员工 ID",
      empno: "工号",
      expand: "展开",
      fax: "传真",
      internal: "内线",
      manager: "主管",
      mobile: "手机",
      other: "其他",
      phone: "固定电话",
      timezone: "时区",
      title: "用户信息: {0}",
      travelcode: "出差联系信息",
      viop: "VIOP",
      zipcode: "邮编"
    },
    richText: {
      bold: "加粗",
      italic: "倾斜",
      underline: "下划线",
      header: "段落格式",
      strike: "删除线",
      blockquote: "块引用",
      codeBlock: "插入代码段",
      size: "字体大小",
      listOrdered: "编号列表",
      listBullet: "项目列表",
      header1: "h1",
      header2: "h2",
      align: "对齐方式",
      color: "字体颜色",
      background: "背景颜色",
      image: "图像",
      video: "视频",
      link: "添加链接",
      formula: "插入公式",
      clean: "清除格式",
      indent1: "向左缩进",
      indent2: "向右缩进",
      pickerLabel: "标题大小",
      headerPicker1: "标题一",
      headerPicker2: "标题二",
      headerPicker3: "标题三",
      headerPicker4: "标题四",
      headerPicker5: "标题五",
      headerPicker6: "标题六",
      normal: "标准",
      sizeSmall: "小号",
      sizeLarge: "大号",
      sizeHuge: "超大号",
      alignPicker1: "居左对齐",
      alignPicker2: "居中对齐",
      alignPicker3: "居右对齐",
      alignPicker4: "两端对齐",
      subScript: "下标",
      superScript: "上标",
      directionRTL: "从右到左",
      font: "字体",
      file: "文件",
      betterTable: "表格",
      fullscreen: "全屏",
      insertColumnRight: "右插入列",
      insertColumnLeft: "左插入列",
      insertRowUp: "上插入行",
      insertRowDown: "下插入行",
      mergeCells: "合并单元格",
      unmergeCells: "拆分单元格",
      deleteColumn: "删除当前列",
      deleteRow: "删除当前行",
      deleteTable: "删除表格",
      colorPicker: "背景颜色",
      placeholder: "在此处插入文本...",
      maxLength: "文本长度超过限制，支持的最大长度是 "
    },
    steps: {
      done: "已完成",
      doing: "进行中",
      wait: "等待中"
    },
    actionSheet: {
      cancel: "取消"
    },
    image: {
      loadFail: "加载失败"
    },
    miniPicker: {
      cancel: "取消",
      confirm: "确定"
    },
    pullRefresh: {
      pullingDown: "下拉即可刷新",
      pullingUp: "上拉即可刷新",
      pulling: "下拉即可刷新",
      loosing: "释放即可刷新",
      success: "刷新成功",
      failed: "刷新失败",
      noMore: "没有更多了"
    },
    currency: {
      defaultCurrency: "默认币种",
      setDefault: "设为默认"
    },
    calendarBar: {
      week: {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六"
      },
      year: "%s年",
      yearMonth: "%y年%m月",
      month: {
        1: "1月",
        2: "2月",
        3: "3月",
        4: "4月",
        5: "5月",
        6: "6月",
        7: "7月",
        8: "8月",
        9: "9月",
        10: "10月",
        11: "11月",
        12: "12月"
      },
      monthAbbr: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      }
    },
    selectedBox: {
      select: "已选（%s）",
      allSelect: "已全选（%s）",
      clear: "清空"
    },
    record: {
      record: "录音",
      cancel: "取消",
      confirm: "确定",
      clickToStartRecording: "点击开始录音",
      clickToResumeRecording: "点击继续录音"
    },
    dialogSelect: {
      treeSearch: "请输入关键字并回车"
    }
  },
  validation: {
    array: {
      len: "%s 的长度必须为 %s",
      min: "%s 长度不能小于 %s",
      max: "%s 的长度不能大于 %s",
      range: "%s 的长度必须介于 %s 和 %s 之间"
    },
    date: {
      format: "%s 日期 %s 对于格式 %s 无效",
      invalid: "%s 日期 %s 无效",
      parse: "无法分析 %s 日期， %s 无效"
    },
    default: "%s 字段校验错误",
    enum: "%s 必须是 %s 中的一个",
    number: {
      len: "%s 必须等于 %s",
      min: "%s 不能小于 %s",
      max: "%s 不能大于 %s",
      range: "%s 必须介于 %s 和 %s 之间"
    },
    pattern: {
      mismatch: "%s 值%s 与模式 %s 不匹配"
    },
    required: "必填",
    string: {
      len: "%s 必须是 %s 个字符",
      min: "%s 必须至少为 %s 个字符",
      max: "%s不 能大于 %s 个字符",
      range: "%s 必须介于 %s 和 %s 个字符之间"
    },
    types: {
      acceptFile: "只接受文件",
      acceptImg: "只接受图片格式",
      array: "非法数组",
      boolean: "非法布尔值",
      date: "不符合规则的日期格式",
      dateTime: "不符合规则的日期时间格式",
      dateYM: "不符合规则的日期格式(yyyy-mm)",
      dateYMD: "不符合规则的日期格式(yyyy-MM-dd)",
      digits: "非法纯数字",
      email: "非法邮件地址",
      fileSize: "文件大小的格式不正确,应如 3kb",
      float: "非法浮点数",
      hex: "非法十六进制",
      integer: "非法整数",
      longDateTime: "不符合规则的长日期格式",
      method: "必须是函数（Function）",
      number: "非法数字",
      object: "非法对象",
      regexp: "非法正则表达式",
      specialch: "只能包含数字、字母、下划线、横杠、点号",
      specialch2: "只能包含数字、字母、下划线、横杠",
      speczh: "只能包含数字、字母、下划线、汉",
      string: "非法字符串",
      time: "不符合规则的时间格式",
      url: "非法 URL 地址",
      version: "非法版本格式"
    },
    whitespace: "%s 不能为空"
  }
};
var enUS$1 = {
  "en-US": "English",
  "zh-CN": "中文",
  "zh-TW": "中国台湾",
  hello: "Hello {name}",
  code: "en-US",
  ui: {
    buttonMessage: {
      cancel: "Cancel",
      confirm: "Confirm"
    },
    wizard: {
      previousStep: "LastStep",
      nextStep: "NextStep",
      save: "Save",
      submit: "Submit"
    },
    linkMenu: {
      title: "news",
      placeholder: "Please enter keywords to filter...",
      sure: "Determine",
      cancel: "cancel"
    },
    todoList: {
      add: "Add",
      placeholder: "please input your todo things"
    },
    alert: {
      error: "Error",
      info: "Info",
      success: "Success",
      title: "Message notification",
      warning: "Warning"
    },
    amount: {
      currency: "Currency",
      amount: "Amount",
      date: "Date"
    },
    actionMenu: {
      moreText: "more"
    },
    base: {
      all: "All",
      cancel: "Cancel",
      confirm: "OK",
      delete: "Delete",
      edit: "Edit",
      more: "More",
      reset: "Reset"
    },
    button: {
      cancel: "Cancel",
      confirm: "OK"
    },
    cell: {
      placeholder: "Select"
    },
    cascader: {
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Select",
      noData: "No data"
    },
    chart: {
      auxiliary: "Auxiliary",
      emptyText: "No Data",
      kName: "Day K",
      other: "Other",
      summation: "Summation",
      total: "Total",
      value: "Value"
    },
    creditCardForm: {
      submit: "Submit"
    },
    crop: {
      cropImage: "crop image",
      croppedImage: "Post-Crop Image"
    },
    datepicker: {
      clear: "Clear",
      cancel: "Cancel",
      endDate: "End Date",
      confirm: "OK",
      month: "month",
      endTime: "End Time",
      month2: "February",
      month1: "January",
      month4: "April",
      month3: "March",
      month6: "June",
      month5: "May",
      month8: "August",
      month7: "July",
      month10: "October",
      month9: "September",
      month12: "December",
      month11: "November",
      months: {
        feb: "Feb",
        jan: "Jan",
        apr: "Apr",
        mar: "Mar",
        jun: "Jun",
        may: "May",
        aug: "Aug",
        jul: "Jul",
        oct: "Oct",
        sep: "Sep",
        dec: "Dec",
        nov: "Nov"
      },
      nextYear: "Next Year",
      nextMonth: "Next Month",
      prevMonth: "Previous Month",
      now: "Now",
      selectDate: "Select date",
      prevYear: "Previous Year",
      startDate: "Start Date",
      selectTime: "Select time",
      today: "Today",
      currentMonth: "Current Month",
      startTime: "Start Time",
      week: "week",
      weeks: {
        mon: "Mon",
        sun: "Sun",
        wed: "Wed",
        tue: "Tue",
        thu: "Thu",
        sat: "Sat",
        fri: "Fri"
      },
      timezone: "selecting a timezone",
      year: "",
      to: "to"
    },
    calendar: {
      showType: {
        year: "year"
      }
    },
    dept: {
      code: "Code",
      company: "Company",
      dept1: "First Level Department",
      dept2: "Second Level Department",
      dept3: "Third Level Department",
      dept4: "Fourth Level Department",
      dept5: "Fifth Level Department",
      dept6: "Sixth Level Department",
      dept7: "Seventh Level Department",
      dept8: "Eighth Level Department",
      input: "Input Dept Code or Name is available",
      name: "Name",
      search: "Quick Search",
      selected: "Selected"
    },
    detailpage: {
      saveButtonText: "Confirm",
      cancelButtonText: "Cancel",
      localTips: "Cannot hide all",
      localTitle: "Data",
      valueTitle: "Click to hide",
      labelTitle: "Title",
      dialogTitle: "Personalized title"
    },
    dialogBox: {
      confirm: "confirm",
      cancel: "cancel"
    },
    load: {
      dot: "Loading"
    },
    exception: {
      build: "Building",
      busy: "The network is busy. Please wait",
      noperm: "Not find the page",
      weaknet: "Poor network performance",
      pcview: "View the file on the PC",
      nodata: "Get some rest",
      create: "Create",
      provide: "Provided by the TINY Team DEV",
      nodatamf: "No data",
      nopermmf: "No access",
      weaknetmf: "Network anomaly",
      noresult: "No result",
      nonews: "No latest news",
      pagenoperm: "403:No access",
      pageweaknet: "Network anomaly",
      pagenothing: "404:The page you visited does not exist",
      pageservererror: "500:Server exception"
    },
    fileUpload: {
      largefile: " is too large and will be uploaded in segments. Please wait.",
      folder: " has more than five layers of folders. The file will not be uploaded",
      init: "Service error. Please try again.",
      token: "Perform EDM authentication first and obtain the token",
      exceed: "Failed to upload the file. The file size exceeds the upper limit ({maxSize} MB).",
      largeFile: "The file size exceeds the upper limit by 2 GB !!!",
      fileSize: "The file size of {name} cannot be less than ",
      deleteTip: "Press delete to remove",
      downloadFile: "DownLoad file",
      previewFile: "Preview file",
      updateFile: "Update file",
      deleteFile: "Delete file",
      empty: "is empty!",
      kiaScanTip: "Sorry, unable to download. Please pass the KIA test first to download a file using public network. Current document is being checked by the KIA, Please wait a while then redownload.",
      fileNameExceeds: "exceeds 255 characters. Please change the file name.",
      fileName: "The file name",
      calcHash: "Document is calculating encryption",
      uploadFile: "Upload file",
      downloadAll: "Download all",
      onlySupport: "Only support {type} file",
      fileNotLessThan: "The file cannot be less than",
      fileNotMoreThan: "The file cannot be more than",
      notSupport: "File upload failed: The format (.{format}) is not supported.",
      attachment: "Attachment",
      uploadList: "Upload List",
      numberExceed: "Failed to upload the file. The number of files to be uploaded in batches exceeds the upper limit ({number})."
    },
    uploadList: {
      pictureUploading: "Picture uploading",
      uploadFailed: "Upload failed",
      uploading: "Uploading",
      download: "Download",
      reUpload: "Re-upload",
      delete: "Delete",
      noAttachments: "No attachments",
      cancel: "Cancel",
      preview: "Preview",
      releaseAndUpload: "Release the mouse and upload the file",
      dragOrClickImport: "Drag the file here, or click Import",
      shoot: "Shoot",
      selectFromAlbum: "Select from album",
      uploadFailedAndReupload: "Upload failed. Click Upload again"
    },
    upload: {
      addPicture: "Add picture",
      addAudio: "Add audio",
      addVideo: "Add video"
    },
    grid: {
      dataUnchanged: "Data unchanged!",
      deleteSelectRecord: "Are you sure you want to delete the selected record?",
      emptyText: "No Data",
      error: {
        cellEditRender: "The renderer cell-render and edit-render cannot be used together.",
        delGetAllRecords: "The function getAllRecords is deprecated, please use getRecordset.",
        delGetRecords: "The function getRecords is deprecated, please use getData.",
        delLabel: "The property label is deprecated, please use title.",
        delProp: "The property prop is deprecated, please use field.",
        delRevert: "The function revert is deprecated, please use revertData.",
        groupFixed: "If grouping headers are used, fixed columns must be on the left and right sides.",
        notDelete: "delete method not exist.",
        notMouse: "Horizontal virtual scrolling does not support mouse-config.",
        notQuery: "query method not exist.",
        notResizable: "Horizontal virtual scrolling does not support resizable.",
        notSave: "save method not exist.",
        reqModule: "require {{name}} module.",
        rowIdEmpty: "The property row-id is not allowed to be empty.",
        scrollOriginal: "Virtual scrolling can only export source data, please set original=true.",
        scrollYHeight: "You must set the height or max-height to enable virtual scrolling.",
        toolbarId: "Toolbar must have a unique id",
        treeFixedExpand: "The fixed columns of the tree structure conflict with the expanded row.",
        treeInsert: "The tree structure does not support insert operations.",
        treeRemove: "The tree structure does not support remove operations.",
        unableInsert: "Unable to insert to the specified location.",
        dargSelf: "Self dragging is not allowed.",
        dargFixed: "Fixed columns cannot be dragged.",
        remoteMethod: '"remoteMethod" needs to be set for remote storage for personalized template management.',
        remoteSelectedMethod: '"remoteSelectedMethod" needs to be set for remote storage for personalized template management.',
        chainCallError: "There is a syntax error in the default slot for the column, please check."
      },
      filter: {
        allFilter: "All",
        allSelect: "(All)",
        endDate: "End Date",
        startDate: "Start Date",
        dateTips: "Please enter at least one date",
        clear: "Clear Current Filter",
        clearAll: "Clear All Filters",
        confirmFilter: "OK",
        empty: "Is Empty",
        emptyText: "No Data",
        equal: "Equal",
        include: "Include",
        prefix: "Starts With",
        resetFilter: "Reset",
        unempty: "Is not Empty"
      },
      individuation: {
        cancelBtn: "Cancel",
        colConfigs: {
          asc: "Ascending",
          desc: "Descending",
          frozenLeft: "Frozen on the left",
          frozenRight: "Frozen on the right",
          invisible: "Invisible",
          unsorted: "No sortting",
          unfrozen: "Unfrozen",
          visible: "Visible",
          unfreeze: "Unfrozen",
          unsort: "Unsort"
        },
        toolbar: {
          set: "Set",
          selected: "Selected",
          freeze: "Freeze",
          sort: "Sort",
          clear: "Clear",
          search: "Search",
          all: "All"
        },
        columnSet: "Column Setting",
        overwriteSave: "Overwrite Save",
        saveAs: "Save as",
        saveTemplate: "Save Template",
        selectTemplate: "Select Template",
        hideMsg: "Leave one column to show at least.",
        maxFreezeNumMsg: "Maxium number of frozen columns is 6",
        defaultTemplateName: "Please enter a name, if not filled in, it will be generated by the system according to time",
        reserveTemplateName: "If the name is not filled in, the previous name will be retained",
        resetBtn: "Reset",
        saveBtn: "OK",
        tabs: {
          base: {
            title: "Base Setting",
            tips: "Click the icon to set personalized."
          },
          other: {
            allDataSort: "Remote Data Sorting",
            currPageSort: "Current Page Data Sorting",
            pageSize: "Page Size",
            title: "Other Setting",
            tips: "Settings for Sorting and Pagesize.",
            sortType: "Sorting Type"
          }
        },
        title: "Personalized Settings",
        switchtitle: "Template Management",
        switchsave: "Save configuration",
        switchlabel: "List:",
        switchapply: "Apply",
        switchedit: "Edit",
        switchdel: "Delete",
        switchconfirm: "Confirm",
        switchonlytemp: "Save as template only",
        switchtempapply: "Save as template and use",
        switchtempoverwrite: "Overwrite template and use",
        switchdelcon: "Are you sure to delete this template?",
        switchdelyes: "Yes",
        switchdelno: "No",
        switchapplycon: "Are you sure to use this template?"
      },
      removeSelectRecord: "Are you sure you want to remove the selected record?",
      saveSuccess: "Save successfully.",
      selectOneRecord: "Please choose at least one piece of record!",
      isSaveMsg: "There are change records, do you want to save them?"
    },
    hrapprover: {
      approver: "Approver",
      noapprover: "There is no approver",
      noselected: "Select one record!",
      remark: "Remarks"
    },
    imageViewer: {
      loadErrorAlt: "Load Error"
    },
    navMenu: {
      moreText: "more"
    },
    logout: {
      in: "Login",
      out: "Logout"
    },
    page: {
      goto: "Go to",
      item: "",
      next: "Next",
      page: "Records/Page",
      pageClassifier: "",
      pagesize: "Records/Page",
      prev: "Prev",
      total: "Total ",
      totals: "Total: ",
      jump: "Go to",
      hundredThousand: "100K+",
      million: "1M+",
      tenMillion: "10M+",
      loadingTotals: "Loading Totals..."
    },
    popeditor: {
      cancel: "Cancel",
      confirm: "OK",
      historyLists: "History options",
      reset: "Reset",
      search: "Search",
      selectionLists: "Selected Items",
      sourceLists: "Available Items",
      title: "Select",
      filterNode: "input text to filter node"
    },
    popupload: {
      fileName: "File Name",
      fileSize: "File Size",
      fileStatus: "File Status",
      dialogTitle: "File Upload",
      cancelButtonText: "Cancel",
      tipsFileText: "upload hints",
      uploadError: "Upload failure!",
      uploadButtonText: "select file",
      uploadSuccess: "Upload Success!",
      saveButtonText: "Click To Upload",
      uploadsButtonText: "select files",
      errorTypeTips: "Upload file type mismatch",
      errorSizeTips: "Upload file size exceeds limit",
      limitUploadFileType: "Upload file type is limited to",
      limitUploadFileNumber: "Limit the number of uploaded files to",
      limitUploadFileSize: "The size of the uploaded file does not exceed",
      errorNumTips: "The number of uploaded files exceeds the limit. The operation has been cancelled"
    },
    rate: {
      level: {
        average: "Average",
        excellent: "Excellent",
        fair: "Fair",
        good: "Good",
        poor: "Poor"
      }
    },
    select: {
      loading: "Loading",
      noData: "No data",
      noMatch: "No matching data",
      placeholder: "Select"
    },
    search: {
      placeholder: "search"
    },
    tabs: {
      moreItem: "more"
    },
    tag: {
      add: "Add"
    },
    toggleMenu: {
      placeholder: "please input filter content"
    },
    treeMenu: {
      placeholder: "please input filter content"
    },
    transfer: {
      filterPlaceholder: "Enter keyword",
      hasCheckedFormat: "{checked}/{total} checked",
      noData: "No data",
      noMatch: "No matching data",
      noCheckedFormat: "{total} items",
      titles: ["List 1", "List 2"]
    },
    tree: {
      emptyText: "No data",
      switchText: "check easily",
      deleteTip: "Data will be permanently deleted, are you sure you want to proceed with the deletion?",
      preserveSubnodeTip: "This node have child nodes, Would you like to preserve the data of the child nodes?",
      preserveSubnodeData: "To preserve child nodes' data.",
      newNodeTitle: "Add Child Nodes"
    },
    usercard: {
      address: "Address",
      collapse: "Collapse",
      department: "Department",
      email: "email",
      employeeId: "Employee ID",
      "employee_id": "Employee ID",
      empno: "Employee Number",
      expand: "Expand",
      fax: "Fax",
      internal: "Internal",
      manager: "Manager",
      mobile: "Mobile",
      other: "Other",
      phone: "Telephone",
      timezone: "Time zone",
      title: "User information: {0}",
      travelcode: "Travel code",
      viop: "VIOP",
      zipcode: "Postal Code"
    },
    richText: {
      bold: "Bold",
      italic: "Tilt",
      underline: "Underline",
      header: "Paragraph Format",
      strike: "Delete Line",
      blockquote: "Block Reference",
      codeBlock: "Insert Code Segment",
      size: "Font Size",
      listOrdered: "No. List",
      listBullet: "Project List",
      header1: "H1",
      header2: "H2",
      align: "Alignment Mode",
      color: "Font Color",
      background: "Background Color",
      image: "Image",
      video: "Video",
      link: "Add Link",
      formula: "Insert Function",
      clean: "Clear Format",
      indent1: "Indent To The Left",
      indent2: "Indent To The Right",
      pickerLabel: "Title Size",
      headerPicker1: "Title 1",
      headerPicker2: "Title 2",
      headerPicker3: "Title 3",
      headerPicker4: "Title 4",
      headerPicker5: "Title 5",
      headerPicker6: "Title 6",
      normal: "Normal",
      sizeSmall: "Small",
      sizeLarge: "Large",
      sizeHuge: "Super Large Size",
      alignPicker1: "Align To The Left",
      alignPicker2: "Align In The Center",
      alignPicker3: "Align To The Right",
      alignPicker4: "Align The Two Ends",
      subScript: "Subscript",
      superScript: "Superscript",
      directionRTL: "Right To Left",
      font: "Font",
      file: "File",
      betterTable: "Table",
      fullscreen: "Fullscreen",
      insertColumnRight: "Insert Column Right",
      insertColumnLeft: "Insert Column Left",
      insertRowUp: "Insert Row Up",
      insertRowDown: "Insert Row Down",
      mergeCells: "Merge Cells",
      unmergeCells: "Split Cells",
      deleteColumn: "Delete Current Column",
      deleteRow: "Delete Current Row",
      deleteTable: "Delete Table",
      colorPicker: "Background Color",
      placeholder: "Insert text here...",
      maxLength: "Text Length exceeds the Limit, max Length config is "
    },
    steps: {
      done: "Completed",
      doing: "Ongoing",
      wait: "Waiting"
    },
    actionSheet: {
      cancel: "Cancel"
    },
    image: {
      loadFail: "Loading failed"
    },
    miniPicker: {
      cancel: "Cancel",
      confirm: "Confirm"
    },
    pullRefresh: {
      pullingDown: "Pull down to refresh",
      pullingUp: "Pull up to refresh",
      pulling: "Pull down to refresh",
      loosing: "Release to refresh",
      success: "Refresh success",
      failed: "Refresh failed",
      noMore: "There is no more"
    },
    currency: {
      defaultCurrency: "Default currency",
      setDefault: "Set as default"
    },
    calendarBar: {
      week: {
        0: "SUN",
        1: "MON",
        2: "TUE",
        3: "WED",
        4: "THU",
        5: "FRI",
        6: "SAT"
      },
      year: "Year %s",
      yearMonth: "%m %y",
      month: {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December"
      },
      monthAbbr: {
        1: "Jan",
        2: "Feb",
        3: "Mar",
        4: "Apr",
        5: "May",
        6: "Jun",
        7: "Jul",
        8: "Aug",
        9: "Sept",
        10: "Oct",
        11: "Nov",
        12: "Dec"
      }
    },
    selectedBox: {
      select: "Selected (%s)",
      allSelect: "All selected (%s)",
      clear: "Clear"
    },
    record: {
      record: "Record",
      cancel: "Cancel",
      confirm: "Confirm",
      clickToStartRecording: "Click to start recording",
      clickToResumeRecording: "Click to resume recording"
    },
    dialogSelect: {
      treeSearch: "Enter a keyword and press Enter"
    }
  },
  validation: {
    array: {
      len: "must be exactly %s in length",
      min: "cannot be less than %s in length",
      max: "cannot be greater than %s in length",
      range: "must be between %s and %s in length"
    },
    date: {
      format: "date %s is invalid for format %s",
      invalid: "date %s is invalid",
      parse: "date could not be parsed, %s is invalid "
    },
    default: "Validation error on field %s",
    enum: "must be one of %s",
    number: {
      len: "must equal %s",
      min: "cannot be less than %s",
      max: "cannot be greater than %s",
      range: "must be between %s and %s"
    },
    pattern: {
      mismatch: "value %s does not match pattern %s"
    },
    required: "required",
    string: {
      len: "must be exactly %s characters",
      min: "must be at least %s characters",
      max: "cannot be longer than %s characters",
      range: "must be between %s and %s characters"
    },
    types: {
      acceptFile: "not a valid %s",
      acceptImg: "not a valid %s",
      array: "not an %s",
      boolean: "not a %s",
      date: "not a %s",
      dateTime: "not a valid %s",
      dateYM: "not a valid %s",
      dateYMD: "not a valid %s",
      digits: "not a valid %s",
      email: "not a valid %s",
      fileSize: "not a valid %s",
      float: "not a %s",
      hex: "not a valid %s",
      integer: "not an %s",
      longDateTime: "not a valid %s",
      method: "not a %s (function)",
      number: "not a %s",
      object: "not an %s",
      regexp: "not a valid %s",
      specialch: "not a valid %s",
      specialch2: "not a valid %s",
      speczh: "not a valid %s",
      string: "not a %s",
      time: "not a valid %s",
      url: "not a valid %s",
      version: "not a valid %s"
    },
    whitespace: "cannot be empty"
  }
};
var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
function format(string) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (args.length === 1 && typeof args[0] === "object") {
    args = args[0];
  }
  if (!args || !args.hasOwnProperty) {
    args = {};
  }
  return string.replace(RE_NARGS, function(match, prefix, i, index2) {
    var result;
    if (string[index2 - 1] === "{" && string[index2 + match.length] === "}") {
      return i;
    } else {
      result = Object.prototype.hasOwnProperty.call(args, i) ? args[i] : null;
      if (result === null || result === void 0) {
        return "";
      }
      return result;
    }
  });
}
var lang = zhCN$1;
var i18nHandler = function i18nHandler2(key, value) {
  var vuei18n = Object.getPrototypeOf(this || Vue).$t;
  if (typeof vuei18n === "function" && vuei18n !== t$1) {
    return vuei18n.apply(this, arguments);
  }
};
var t$1 = function t$12(path, options) {
  if (options === void 0) {
    options = void 0;
  }
  var message = i18nHandler.apply(this, arguments);
  if (message === null || message === void 0 || message === path) {
    var paths = path.split(".");
    var current = lang;
    for (var pos = 0, len = paths.length; pos < len; pos++) {
      var property = paths[pos];
      message = current[property] || "";
      if (pos === len - 1)
        return format(message, options);
      if (!message)
        return "";
      current = message;
    }
    return "";
  } else {
    return message;
  }
};
var use$1 = function use$12(language2) {
  lang = language2 || lang;
  return lang;
};
var language$1 = function language$12() {
  return lang.code;
};
var i18n$1 = function i18n$12(func) {
  i18nHandler = func || i18nHandler;
  return i18nHandler;
};
var extend$1 = extend$2;
var initI18n$1 = function initI18n$12(_ref) {
  var VueI18n = _ref.VueI18n, _ref$messages = _ref.messages, messages = _ref$messages === void 0 ? {} : _ref$messages, _ref$i18n = _ref.i18n, i18n2 = _ref$i18n === void 0 ? {} : _ref$i18n, merge = _ref.merge;
  if (typeof merge !== "function") {
    merge = function merge2(_ref2) {
      var lang3 = _ref2.lang, i18n3 = _ref2.i18n, messages2 = _ref2.messages;
      return extend$1.call(null, true, lang3, i18n3.messages, messages2);
    };
  }
  var lang2 = {
    zhCN: zhCN$1,
    enUS: enUS$1
  };
  if (typeof VueI18n === "function") {
    var vueI18n = new VueI18n({
      locale: i18n2.locale || "zhCN",
      messages: merge({
        lang: lang2,
        i18n: i18n2,
        messages
      })
    });
    i18nHandler = function i18nHandler3(key, value) {
      return vueI18n.t(key, value);
    };
    return vueI18n;
  }
  if (Vue && typeof Vue.prototype.$t !== "function") {
    Vue.prototype.$t = t$1;
  }
  return merge({
    lang: lang2,
    i18n: i18n2,
    messages
  });
};
var isVue2 = true;
var isVue3 = false;
var index$1 = {
  isVue2,
  isVue3,
  extend: extend$1,
  i18n: i18n$1,
  initI18n: initI18n$1,
  t: t$1,
  use: use$1,
  enUS: enUS$1,
  zhCN: zhCN$1
};
var vue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: index$1,
  enUS: enUS$1,
  extend: extend$1,
  i18n: i18n$1,
  initI18n: initI18n$1,
  isVue2,
  isVue3,
  language: language$1,
  t: t$1,
  use: use$1,
  zhCN: zhCN$1
}, Symbol.toStringTag, {
  value: "Module"
}));
var getNumberFormat = function getNumberFormat2(config) {
  var groupSize = 3;
  var groupSeparator = ",";
  var decimalSeparator = ".";
  if (isPlainObject(config)) {
    return config;
  }
  if (typeof config === "string") {
    var match = config.match(/\d{2}([^\d]?)\d{3}([^\d]?)\d{2}/);
    if (match && match.length === 3) {
      groupSeparator = match[1];
      decimalSeparator = match[2];
    }
  }
  return {
    groupSeparator,
    groupSize,
    decimalSeparator
  };
};
var getDateFormat = function getDateFormat2(config) {
  var _config$DateFormat = config.DateFormat, DateFormat = _config$DateFormat === void 0 ? "yyyy-MM-dd" : _config$DateFormat, _config$TimeFormat = config.TimeFormat, TimeFormat = _config$TimeFormat === void 0 ? "HH:mm:ss" : _config$TimeFormat;
  return {
    DateFormat,
    DateTimeFormat: DateFormat + " " + TimeFormat,
    TimeFormat
  };
};
var TZRE = /(-|\+)(\d{2}):?(\d{2})$/;
var getStrTimezone = function getStrTimezone2(value) {
  var localTimeZone = 0 - /* @__PURE__ */ (/* @__PURE__ */ new Date()).getTimezoneOffset() / 60;
  var match = typeof value === "string" && value.match(TZRE);
  if (match) {
    var minoffset = match[2] * 1 + match[3] * 1 / 60;
    value = minoffset * (match[1] + "1");
  }
  if (isNumber(value) && value >= -12 && value <= 12) {
    return value;
  }
  return localTimeZone;
};
function glob(t2) {
  return function(config) {
    var opt = _extends({}, getDateFormat(config), {
      NumberFormat: getNumberFormat(config.NumberFormat),
      DbTimezone: getStrTimezone(config.DbTimezone),
      Timezone: getStrTimezone(config.Timezone)
    });
    var tools = {
      getFormatConfig: function getFormatConfig() {
        return opt;
      },
      setFormatConfig: function setFormatConfig(obj) {
        Object.assign(opt, obj);
      },
      getNumberFormat: function getNumberFormat3() {
        return opt.NumberFormat;
      },
      getDateFormat: function getDateFormat3() {
        return {
          DateTimeFormat: opt.DateTimeFormat,
          TimeFormat: opt.TimeFormat,
          Timezone: opt.Timezone,
          DateFormat: opt.DateFormat,
          DbTimezone: opt.DbTimezone
        };
      },
      /**
       *
       * @param {Date|String} value 日期或日期字符串
       * @param {String} format 格式化模式
       * @returns {String}
       */
      formatDate: function formatDate(value, format2) {
        if (isNull(value)) {
          return value;
        }
        var date = isDate(value) ? value : toDate(value);
        var dbtimezone = opt.DbTimezone;
        var includeTz = value.match && value.match(TZRE);
        var convers = format2 === false || arguments[2] === false;
        if (includeTz) {
          dbtimezone = getStrTimezone(value);
          date = toDate(value.replace("T", " ").slice(0, -5));
        }
        if (!convers) {
          date = this.getDateWithNewTimezone(date, dbtimezone, opt.Timezone);
        }
        return isDate(date) ? _formatDate(date, format2 || opt.DateFormat, t2) : null;
      },
      /**
       *
       * @param {Number} value 数字
       * @param {Object} format 格式化选项
       * @returns {String}
       */
      formatNumber: function formatNumber(value, format2) {
        return _formatNumber(value, _extends({}, opt.NumberFormat, format2));
      },
      /**
       *
       * @param {String} value 格式化后的字符串
       * @param {Object} format 格式化选项
       * @returns {Number}
       */
      recoverNumber: function recoverNumber(value, format2) {
        return _recoverNumber(value, _extends({}, opt.NumberFormat, format2));
      },
      /**
       *
       * @param {Date} value Date
       * @param {Number} from
       * @param {Number} to
       * @returns {String}
       */
      getDateWithNewTimezone: function getDateWithNewTimezone(value, from, to) {
        from = from === 0 ? from : from || opt.DbTimezone;
        to = to === 0 ? to : to || opt.Timezone;
        return _getDateWithNewTimezone(value, from, to);
      }
    };
    return tools;
  };
}
var version = "2.10.0";
var use = vue.use, t = vue.t, i18n = vue.i18n, initI18n = vue.initI18n, extend = vue.extend, zhCN = vue.zhCN, enUS = vue.enUS, language = vue.language;
var globalization = glob(t);
var index = _extends({}, index$1, {
  language,
  globalization
});
export {
  index as default,
  enUS,
  extend,
  globalization,
  i18n,
  initI18n,
  language,
  t,
  use,
  version,
  zhCN
};
